import { getAggsItems } from "./esUtils";
export const processAggregations = (aggregations) => {
    return aggregations.map((f) => {
        const { id, items, sum_other_doc_count } = f;
        const itemsProcessed = getAggsItems(id, items);
        return {
            id,
            items: itemsProcessed,
            sum_other_doc_count,
        };
    });
};
